import { routes } from './routes';
import { RoutePaths } from './route-paths';
import { useLoggingInStore } from '../pinia/store';
import { createRouter, createMemoryHistory } from 'ui.vue3.router';

const history = createMemoryHistory();
history.replace(RoutePaths.SIGN_IN);
const router = createRouter({ routes, history });

router.afterEach((to, from) => {
	const scenarioStore = useLoggingInStore();
	// Assuming no CAPTCHA legal link on a page by default
	scenarioStore.hideCaptchaLegalLink();
});

export { router };
